export abstract class HttpService {
  abstract get<T, Config = any>(url: string, config?: Config): Promise<T>
  abstract post<T, Body = any, Config = any>(
    url: string,
    body: Body,
    config?: Config
  ): Promise<T>

  abstract put<T, Body = any, Config = any>(
    url: string,
    body: Body,
    config?: Config
  ): Promise<T>

  abstract delete<T, Config = any>(url: string, config?: Config): Promise<T>
  abstract patch<T, Body = any, Config = any>(
    url: string,
    body: Body,
    config?: Config
  ): Promise<T>
}

export class HttpRequestService {
  constructor(private httpService: HttpService) {
    this.httpService = httpService
  }

  async get<T, P extends Record<any, any> = any, C = any>(
    url: string,
    body?: P,
    config?: C
  ) {
    const params = new URLSearchParams(body).toString()
    const urlWithParams = params ? `${url}?${params}` : url
    return this.httpService.get<T, C>(urlWithParams, config)
  }

  async post<T, B = any, C = any>(url: string, body?: B, config?: C) {
    return this.httpService.post<T>(url, body, config)
  }

  async put<T, B = any, C = any>(url: string, body?: B, config?: C) {
    return this.httpService.put<T>(url, body, config)
  }

  async delete<T, C = any>(url: string, config?: C) {
    return this.httpService.delete<T>(url, config)
  }

  async patch<T, B = any, C = any>(url: string, body?: B, config?: C) {
    return this.httpService.patch<T>(url, body, config)
  }
}
